<template>
  <div>
    <vs-table :data="sharedLinks">
      <template slot="header">
      </template>
      <template slot="thead">
        <vs-th style="min-width:150px;">
          Share Type
        </vs-th>
        <vs-th>
          Target Audience
        </vs-th>
        <vs-th>
          Shared By
        </vs-th>
        <vs-th>
          Date Shared
        </vs-th>
        <vs-th>
          Expires
        </vs-th>
        <vs-th>
          Share Link
        </vs-th>
        <vs-th>
          Actions:
        </vs-th>
      </template>

      <template slot-scope="{data}">
                 <vs-tr :key="indextr" v-for="(tr, indextr) in data" :class="{ 'expired-row': data[indextr].IsExpired }">
           <vs-td :data="data[indextr].ShareObjectType" valign="top">
             {{ShareObjectDict[data[indextr].ShareType]}}
           </vs-td>

           <vs-td :data="data[indextr].TargetAudience" valign="top">
             <span v-if="data[indextr].ShareType == 1">
               Anyone with email in the
             </span>
             <strong v-if="data[indextr].ShareType != 4">{{data[indextr].TargetAudience}}</strong>

             <span v-if="data[indextr].ShareType == 1">
               domain will be able to access this SOP after email verification.
             </span>

             <span v-if="data[indextr].ShareType == 0">
               will be able to access this SOP after email verification.
             </span>
             <span v-if="data[indextr].ShareType == 2">
               Anyone having this link can open the SOP without being challenged over email or logged in.
             </span>
             <span v-if="data[indextr].ShareType == 4">
               Anyone in the <strong>{{data[indextr].TargetAudience}}</strong> role can access this SOP.
             </span>
           </vs-td>
           
           <vs-td :data="data[indextr].SharedByUser" valign="top">
             <div v-if="data[indextr].SharedByUser">
               <strong>{{getUserDisplayName(data[indextr].SharedByUser)}}</strong>
               <br />
               <small class="text-muted">{{data[indextr].SharedByUser.Email}}</small>
             </div>
             <span v-else-if="data[indextr].ShareType == 4" class="text-muted">N/A</span>
             <span v-else class="text-muted">Unknown</span>
           </vs-td>
           
           <vs-td :data="data[indextr].Date" valign="top">
             <span v-if="data[indextr].Date">{{formatDate(data[indextr].Date)}}</span>
             <span v-else-if="data[indextr].ShareType == 4" class="text-muted">N/A</span>
             <span v-else class="text-muted">N/A</span>
           </vs-td>
           
           <vs-td :data="data[indextr].ExpirationDate" valign="top">
             <div v-if="data[indextr].ShareType == 4" class="text-muted">
               N/A
             </div>
             <div v-else :class="{ 'expired': data[indextr].IsExpired }">
               {{formatDate(data[indextr].ExpirationDate)}}
               <br />
               <small v-if="data[indextr].IsExpired" class="text-danger">
                 <strong>EXPIRED</strong>
               </small>
               <small v-else class="text-muted">
                 {{getTimeUntilExpiration(data[indextr].ExpirationDate)}}
               </small>
             </div>
           </vs-td>
          
                     <vs-td :data="data[indextr].ShareLink" valign="top">
             <vs-button 
               color="primary" 
               @click="copyShareLink(data[indextr])" 
               size="small" 
               icon="content_copy" 
               :disabled="data[indextr].IsExpired"
               :title="getShareLink(data[indextr])"
             />
           </vs-td>
          
                     <vs-td valign="top">
             <vs-button 
               v-if="data[indextr].ShareType != 4"
               color="danger" 
               @click="DeleteSharedItem(tr.Id,indextr)" 
               icon="delete" 
               size="small" 
               class="ml-2" 
             />
           </vs-td>
        </vs-tr>
      </template>
    </vs-table>

  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import moment from "vue-moment";

  export default {
    mounted() {
      this.LoadSharedLinks()
    },
    data() {
      return {
        sharedLinks: [],
        ShareOptions: [
          { label: 'Specific person', value: '0', example: 'e.g. someone@somedomain.com' },
          { label: 'Company domain', value: '1', example: 'e.g. tcvelik.com to share with everyone who has @tcvelik.com email' },
          { label: 'Anyone with the link', value: '2' },
          { label: 'Role', value: '3' }],
                 ShareObjectDict: {
           0: 'Specific person',
           1: 'Company domain',
           2: 'Anyone with the link',
           3: 'Role',
           4: 'Role'
         }
      }

    },
    props: ["shareObjectId","shareObjectType"],
    methods: {
      LoadSharedLinks() {
        var instance = this;
        TCVelikClient.GetRelative("/api/share/GetAllSharedItems?id=" + instance.shareObjectId + "&shareObjectType=" + instance.shareObjectType)
          .then(function (response) {
            if (response && response.data && response.data) {
              instance.sharedLinks = response.data
            }
            else if (response && response.data && response.data.errors) {
              alert('There were some errors loading the shared links');
            }
          });
      },
      getUserDisplayName(user) {
        if (user.FirstName && user.LastName) {
          return `${user.FirstName} ${user.LastName}`;
        } else if (user.FirstName) {
          return user.FirstName;
        } else if (user.UserName) {
          return user.UserName;
        } else {
          return user.Email;
        }
      },
             formatDate(dateString) {
         const moment = require("moment");
         return moment(dateString).format('MMM DD, YYYY');
       },
      getTimeUntilExpiration(expirationDate) {
        const moment = require("moment");
        const now = moment();
        const expiration = moment(expirationDate);
        const diff = expiration.diff(now, 'days');
        
        if (diff < 0) {
          return 'Expired';
        } else if (diff === 0) {
          return 'Expires today';
        } else if (diff === 1) {
          return 'Expires tomorrow';
        } else if (diff < 7) {
          return `Expires in ${diff} days`;
        } else if (diff < 30) {
          const weeks = Math.floor(diff / 7);
          return `Expires in ${weeks} week${weeks > 1 ? 's' : ''}`;
        } else {
          return 'Valid';
        }
      },
             getShareLink(sharedItem) {
         // Build the share link using the same logic as the backend
         const host = window.location.origin;
         
         if (sharedItem.ShareType == 4) {
           // Role assignment - return direct SOP link
           if (this.shareObjectType == 0) {
             // Onboarding
             return `${host}/pages/pdf-view?oid=${this.shareObjectId}`;
           } else if (this.shareObjectType == 1) {
             // Space
             return `${host}/pages/space/${this.shareObjectId}`;
           }
         } else {
           // Regular share link with token
           const token = sharedItem.Token;
           
           if (this.shareObjectType == 0) {
             // Onboarding
             return `${host}/pages/pdf-view?oid=${this.shareObjectId}&token=${token}`;
           } else if (this.shareObjectType == 1) {
             // Space
             return `${host}/pages/space/${this.shareObjectId}?spaceToken=${token}`;
           }
         }
         
         return '';
       },
      copyShareLink(sharedItem) {
         const link = this.getShareLink(sharedItem);
         if (link) {
           console.log('Copying link:', link); // Debug log
           this.$copyText(link).then(() => {
             console.log('Copy successful'); // Debug log
             this.$vs.notify({
               title: "Success!",
               text: sharedItem.ShareType == 4 ? "SOP link copied to clipboard" : "Link copied to clipboard",
               color: "success",
               iconPack: "feather",
               position: "top-center",
               icon: "icon-check-circle",
               time: 3000, // Show for 3 seconds
             });
           }).catch((error) => {
             console.error('Copy failed:', error); // Debug log
             this.$vs.notify({
               title: "Error",
               text: "Failed to copy link",
               color: "danger",
               iconPack: "feather",
               position: "top-center",
               icon: "icon-alert-circle",
               time: 3000, // Show for 3 seconds
             });
           });
         } else {
           console.error('No link to copy'); // Debug log
           this.$vs.notify({
             title: "Error",
             text: "No link available to copy",
             color: "warning",
             iconPack: "feather",
             position: "top-center",
             icon: "icon-alert-circle",
             time: 3000, // Show for 3 seconds
           });
         }
       },
      DeleteSharedItem(id,position) {
        var instance = this;
        TCVelikClient.PostRelative("/api/share/DeleteSharedLink?id=" + id)
          .then(function (response) {
            if (response.status == 200) {
              instance.$vs.notify({
                title: "Deleted shared link",
                color: "success",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
              instance.sharedLinks.splice(position,1)
            }
            else if (response.status != 200) {
              instance.$vs.notify({
                title: "Failed to delete shared link",
                color: "failure",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
          });
      }
    },
    components: {
      moment
    }
  }
</script>

<style>
.text-muted {
  color: #6c757d;
  font-size: 0.875em;
}

.text-danger {
  color: #dc3545;
  font-size: 0.875em;
}

.expired {
  color: #dc3545;
}

.expired-row {
  opacity: 0.6;
  background-color: #f8f9fa;
}
</style>
